import { useId } from "react";
import { Dialog } from "@hireart/component-library";
import clsx from "clsx";
import PropTypes from "prop-types";
import { ModalActions } from "./ModalActions";
import { ModalContent } from "./ModalContent";
import { ModalDimmer } from "./ModalDimmer";
import { ModalHeader } from "./ModalHeader";
import { ModalLabelContext } from "./ModalLabelContext";

const ModalDescription = (props) => <div {...props} />;

export const Modal = ({
  children,
  className = "",
  closeIcon,
  closeOnDimmerClick,
  closeOnEscape,
  dimmer,
  onOpen,
  open = false,
  size,
  trigger,
  ...props
}) => {
  const labelId = useId();

  return (
    <>
      {trigger}
      {open && (
        <ModalLabelContext.Provider value={labelId}>
          <Dialog
            {...props}
            aria-labelledby={labelId}
            className={clsx("ha-modal", className)}
            isOpen={open}
          >
            {children}
          </Dialog>
        </ModalLabelContext.Provider>
      )}
    </>
  );
};

/* eslint-disable react/boolean-prop-naming */
Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeIcon: PropTypes.bool,
  closeOnDimmerClick: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
  dimmer: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
  size: PropTypes.string,
  trigger: PropTypes.node,
};
/* eslint-enable react/boolean-prop-naming */

Modal.Actions = ModalActions;
Modal.Content = ModalContent;
Modal.Description = ModalDescription;
Modal.Dimmer = ModalDimmer;
Modal.Header = ModalHeader;
